<div class="rounded-lg bg-third-level/40 p-4" [attr.data-testid]="testId()">
  <p class="mb-6 text-sm opacity-80">{{ hintKey() | transloco }}</p>

  <div class="space-y-3" [attr.data-testid]="testId() + '-rows'">
    @for (row of rows(); track row.item.id; let index = $index) {
      <div class="flex items-center gap-3" [attr.data-testid]="testId() + '-row-' + row.item.id">
        <div
          class="min-w-[44px] px-3 py-3 bg-third-level rounded-lg flex items-center justify-center shrink-0"
        >
          <span class="text-sm" [attr.data-testid]="testId() + '-position-' + row.item.id">
            {{ row.position }}
          </span>
        </div>
        <div
          class="min-w-[60px] px-3 py-3 bg-third-level rounded-lg flex items-center justify-center shrink-0"
        >
          <span class="text-sm">{{ row.item.identifier }}</span>
        </div>
        <div class="flex-1 px-4 py-3 bg-third-level rounded-lg flex items-center min-w-0">
          <span class="truncate" [attr.data-testid]="testId() + '-name-' + row.item.id">
            {{ row.item.translations | translateDirectus }}
          </span>
        </div>
        <div class="flex items-center gap-2 shrink-0">
          <p-button
            icon="pi pi-arrow-up"
            styleClass="btn-select-dark ranking-move-button"
            [disabled]="row.movesUpDisabled"
            [pTooltip]="moveUpKey() | transloco"
            [attr.data-testid]="testId() + '-move-up-' + row.item.id"
            (onClick)="moveUp(index)"
          ></p-button>
          <p-button
            icon="pi pi-arrow-down"
            styleClass="btn-select-dark ranking-move-button"
            [disabled]="row.movesDownDisabled"
            [pTooltip]="moveDownKey() | transloco"
            [attr.data-testid]="testId() + '-move-down-' + row.item.id"
            (onClick)="moveDown(index)"
          ></p-button>
        </div>
      </div>
    }
  </div>
</div>
